import { shorthands, makeStyles } from '@fluentui/react-components';

export const useFluentV1Styles = makeStyles({
  root: {
    ...shorthands.border('1px', 'solid', 'rgb(96, 94, 92)'),
    ':focus-within': {
      ...shorthands.border('1px', 'solid', 'rgb(0, 120, 212)'),
    },
    ':focus-within:hover': {
      ...shorthands.border('1px', 'solid', 'rgb(0, 120, 212)'),
    },
    ':hover': {
      ...shorthands.border('1px', 'solid', 'rgb(50, 49, 48)'),
    },
    '::after': {
      display: 'none',
    },
    ...shorthands.borderRadius('2px'),
  },
});
